import {
  CREATE_SUPPORT_TICKET_FAILURE,
  CREATE_SUPPORT_TICKET_REQUEST,
  CREATE_SUPPORT_TICKET_SUCCESS,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    error: false,
    message: null,
  };
};

const initialState = getInitialState();

const support = (state = initialState, action) => {
  const types = {
    [CREATE_SUPPORT_TICKET_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [CREATE_SUPPORT_TICKET_SUCCESS]: () => ({
      isLoading: false,
      error: false,
      message: null,
    }),
    [CREATE_SUPPORT_TICKET_FAILURE]: () => ({
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default support;
